import React from 'react';
import ReactDOM from 'react-dom';
import MeetingsItem from './meetings-item.jsx';
import LoadMore from './load-more.jsx';
import { populate } from './../utils/populate.js';

class Meetings extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/meetings?_format=json",
      query: "",
      data: [],
      preloadData: [],
      loadMore: false,
      page: 0,
      pageCount: 9
    };

    this.populateAll = this.populateAll.bind(this);
    this.prePopulate = this.prePopulate.bind(this);
    this.processChange = this.processChange.bind(this);
  }

  componentDidMount() {

    var meetingsQuery = document.getElementById("react--related--terms").dataset.term;

    this.setState({
      query: meetingsQuery
    }, () => {
      this.populateAll();
      this.prePopulate();
    })
  }



  populateAll() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}&page=${that.state.page}&committee=${query}`).then(function( response ){
      that.setState({
        data: response
      })
    });
  }

  prePopulate() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}&page=${that.state.page + 1}&committee=${query}`).then(function( response ){
      if(response.length !== 0){
        that.setState({
          preloadData: response,
          loadMore: true
        })
      }else{
        that.setState({
          preloadData: [],
          loadMore: false
        })
      }
    });
  }

  processChange() {
    if (this.state.preloadData.length < this.state.pageCount){
        this.setState({
        data: this.state.data.concat(this.state.preloadData),
        preloadData: [],
        loadMore: !1
      });
    } else {
      var e = parseInt(this.state.page) + 1;
      this.setState({
        page: e,
        data: this.state.data.concat(this.state.preloadData),
        preloadData: []
      }, () => {
        this.prePopulate()
      })
    }
  }

  render() {
    const { data, loadMore} = this.state;

      return(
        <div className="react--meetings page--section background__mist border__bottom">

          <div className="container">
            <h2 className="heading heading__large">Schedule of Meetings and Latest Papers</h2>
            <div className="publication--articles--holder grid">
          {
            data.map((item, index) => {
                return(
                  <MeetingsItem item={item} key={index} />
                );

            })
          }
            </div>

          { data.length !== 0 && <LoadMore display={loadMore} onUpdate={this.processChange} /> }
          </div>
        </div>
      )
  }
}

if ( document.getElementById('react--schedule--meetings') ) {
  ReactDOM.render(
    <Meetings/>,
    document.getElementById('react--schedule--meetings')
  );

}









